import { Component, inject, Input } from '@angular/core';
import { BuildingSectionItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-building-section-badge',
  templateUrl: './building-section-badge.component.html',
  styleUrls: ['./building-section-badge.component.scss']
})
export class BuildingSectionBadgeComponent {
  readonly router = inject(Router);

  @Input()
  @Tracked()
  buildingSection?: BuildingSectionItemDto;

  @Input()
  @Tracked()
  disableLink = false;
}
